import numeral from "numeral";

export default value => numeral(value).format("0,0[.]00");
